import { IAuthByPinRequestOptions, IAuthByProviderRequestOptions, IAuthRequestOptions } from "../Interfaces/AuthRequest";
import {
    oauthLogInByPinRoute,
    oauthLogInByProviderRoute,
    oauthLogInRoute,
    oauthLogInWithAccountLinkRoute
} from "../Stores/Auth/types";

export function PostOAuthSignInByPinForm(options: IAuthByPinRequestOptions, queryParams: string) {
    const postForm = document.createElement("form");
    postForm.action = oauthLogInByPinRoute + queryParams;
    postForm.method = "POST";

    postForm.innerHTML = `
            <input type="hidden" name="location" value="${options.location}" />
            <input type="hidden" name="pin" value="${options.pin}" />
            <input type="submit" style="visibility: hidden;"/>`;
    document.querySelector("body").appendChild(postForm);
    postForm.submit();
}

export function PostOAuthSignInForm(options: IAuthRequestOptions, queryParams: string, shouldLinkAccounts?: boolean) {
    const postForm = document.createElement("form");
    postForm.action = (shouldLinkAccounts ? oauthLogInWithAccountLinkRoute : oauthLogInRoute) + queryParams;
    postForm.method = "POST";

    postForm.innerHTML = `
            <input type="hidden" name="location" value="${options.location}" />
            <input type="hidden" name="name" value="${options.name}" />
            <input type="hidden" name="password" value="${options.password}" />
            <input type="submit" style="visibility: hidden;"/>`;
    document.querySelector("body").appendChild(postForm);
    postForm.submit();
}
export function PostOAuthProviderForm(queryParams: string, options: IAuthByProviderRequestOptions) {
    const postForm = document.createElement("form");
    postForm.action = oauthLogInByProviderRoute + queryParams;
    postForm.method = "POST";

    postForm.innerHTML = `
            <input type="hidden" name="oAuthProviderId" value="${options.oAuthProviderId}" />
            <input type="hidden" name="locationId" value="${options.locationId}" />
            <input type="hidden" name="ssoPostBack" value="${options.ssoPostBack}" />
            <input type="hidden" name="ssoPostBackMode" value="${options.ssoPostBackMode}" />
            <input type="hidden" name="ssoPostBackHash" value="${options.ssoPostBackHash.replace(
        "#",
        ""
    )}" />
            <input type="hidden" name="associatedPersonId" value="${options.associatedPersonId}" />
            <input type="submit" style="visibility: hidden;"/>`;
    document.querySelector("body").appendChild(postForm);
    postForm.submit();
}

